import Layout from "../Layouts/Layout.jsx";

export default function Support() {
  return (
    <Layout title="Support">
      <div className="container w-full rounded-xl bg-white dark:bg-gray-800 shadow p-4 min-h-40">
        <p className="text-gray-700 dark:text-gray-200">
          Questions or problems? Email us at{" "}
          <a
            href="mailto:support@fungistics.com"
            className="underline text-brand dark:text-brand-onDark"
          >
            support@fungistics.com
          </a>{" "}
          and we will get back to you.
        </p>
      </div>
    </Layout>
  )
}
